import { Component, OnInit } from '@angular/core';
import { Validators, FormBuilder } from '@angular/forms';
import { UserService } from 'src/app/service/user.service';
import { Router } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { BsModalService } from 'ngx-bootstrap';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss']
})
export class UserProfileComponent implements OnInit {
  userForm: any;
  isLoading: any;
  user: any;

  constructor(private formBuilder: FormBuilder, private route: Router, private notifier: NotifierService,
              private userService: UserService, private modalService: BsModalService,) {

    this.user = JSON.parse(localStorage.getItem('user'));

    this.userForm = this.formBuilder.group({
      username: ["", [Validators.required]],
      email: ["", [Validators.required]],
      mobileNo: ["", [Validators.required]]

    });

  }

  ngOnInit() {
    this.userForm.controls['username'].setValue(this.user.username);
    this.userForm.controls['email'].setValue(this.user.email);
    this.userForm.controls['mobileNo'].setValue(this.user.mobileNo);
  }

  change() {
    this.isLoading = true;
    let req = {
      id: this.user.id,
      username:this.userForm.controls.username.value,
      email:this.userForm.controls.email.value,
      mobileNo:this.userForm.controls.mobileNo.value,
    }
    this.userService.newUser(req).subscribe(
      res=>{
        if (res.responseCode == 200) {
          this.isLoading = false;
          this.notifier.notify('success', res.responseDesc);
        } else {
          this.isLoading = false;
          this.notifier.notify('danger', res.responseDesc);
        }
      }
    )
  }
}
